import { Component, OnInit } from '@angular/core';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {Keepalive} from '@ng-idle/keepalive';
import { Router,RouterModule} from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { sha256, sha224 } from 'js-sha256';
import { ServerConstantsService } from '../serverConstants.service';

@Component({
  selector: 'app-timeout',
  templateUrl: './timeout.component.html',
  styleUrls: ['./timeout.component.scss']
})
export class TimeoutComponent implements OnInit {
  close:Boolean = false;
  logout:Boolean = false;
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;

  constructor(private idle: Idle, private keepalive: Keepalive, public router:Router) {
    idle.setIdle(840);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(60);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.'});
    idle.onTimeout.subscribe(() => {
      sessionStorage.clear();
      this.close = false;
      this.logout = true;
      this.idleState = 'Timed out!';
      this.timedOut = true;
    });
    idle.onIdleStart.subscribe((countdown) => {
      this.idleState = 'You\'ve gone idle!'});
    idle.onTimeoutWarning.subscribe((countdown) => {
      this.close = true;
      this.idleState = 'You will time out in ' + countdown + ' seconds!'});

    // sets the ping interval to 15 seconds
    //keepalive.interval(15);

    //keepalive.onPing.subscribe(() => this.lastPing = new Date());

    this.reset();
   }

  ngOnInit() {
  }
  continue(){
    this.reset();
    this.close = false;
  }
  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }
  signoff(){
      
      this.logout = false;
      let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
     CryptoJS.AES.decrypt(sessionStorage.getItem('conversion_stat'), key).toString(CryptoJS.enc.Utf8) === 'true' ?  window.location.replace(ServerConstantsService.serverConstants.ariesUrl) :
    this.router.navigate(['login']);
    sessionStorage.clear();
  }

}



// WEBPACK FOOTER //
// ./src/app/timeout/timeout.component.ts